// Module
var code = "<h1 id=number-数字输入>Number 数字输入</h1> <p>数字输入控件。</p> <p>仅允许输入标准的数字值，可定义范围</p> <h2 id=何时使用>何时使用</h2> <ul> <li>....。</li> </ul> ";
// Exports
module.exports = code;